import React from 'react'
import AboutNavBar from '../components/AboutNavBar'
import NotFound from '../components/NotFound'
import Footer from '../components/Footer'
import RenderLinks from '../components/RenderLinks'

function NotFoundPage() {
  return (
    <div>
      {/* <RenderLinks/> */}
      <AboutNavBar/>
      <NotFound/>
      <ter/>
    </div>
  )
}

export default NotFoundPage
